import Label from "./elem/label";
import Subtitle from "./elem/subtitle";
import Title from "./elem/title";
import Field from "./field";
import Group from "./group";
import Header from "./header";
import Item from "./item";

export default { Item, Field, Header, Group, Elem: { Label, Title, Subtitle } };
